// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;
